import { render } from "./gestionClases.vue?vue&type=template&id=ee9de4d6&scoped=true"
import script from "./gestionClases.vue?vue&type=script&lang=js"
export * from "./gestionClases.vue?vue&type=script&lang=js"

import "./gestionClases.vue?vue&type=style&index=0&id=ee9de4d6&scoped=true&lang=css"

import exportComponent from "C:\\ProductFactory\\analiaperez-landing\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee9de4d6"]])

export default __exports__